import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useParams,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import useHttpHook from "../../../Hooks/HttpHook";
import { increaseCounter } from "../../../ReduxSlice/Guard/checkInCheckoutSlice";
import { MarkAttendeeCheckInOrCheckOut } from "../../../utils/ApiConstant";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import ModalWrapper from "../../Common/Portals/ModalWrapper";
import AttendeeProfileCard from "./AttendeeProfileCard";
import CheckInCheckoutTabel from "./CheckInCheckoutTabel";
import EventCard from "./EventCard";
import { toast } from "react-toastify";
import { redirectUnauthorized } from "../../../utils/Helper";
import { showErrorToast } from "../../../utils/notify";

const AttendeeDetials = ({
  details,
  isLoading,
  isError,
  getDetails,
  setDetails,
}) => {
  const [loading, sendRequest, error] = useHttpHook();
  const { attendeeId } = useParams();
  const { token } = useSelector((state) => state.guard);
  const [status, setStatus] = useState(null);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  let varify = query.get("varify");
  // let isMark = query.get("isMark");
  // const { count, attendee } = useSelector((state) => state.checkInCheckOut);
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  // const navigate = useNavigate();
  // const [searchParams] = useSearchParams();
  // console.log(details, "details-----------------");
  // useEffect(() => {
  //   if (
  //     location.pathname === `/guard/attendees/${attendeeId}` &&
  //     varify === null &&
  //     count > 0
  //   ) {
  //     window.onload = () => {
  //       if (!window.location.hash) {
  //         window.location = window.location + "#loaded";
  //         window.location.reload();
  //       }
  //     };
  //   }
  // }, []);

  // useEffect(() => {
  //   console.log({ varify });
  // }, [varify]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          redirectUnauthorized({
            forceGuard:
              Boolean(token) || location.pathname.startsWith("/guard/"),
          });
        }
      }
    }
  }, [error, token, location.pathname, navigate]);

  // useEffect(() => {
  //   if (
  //     location.pathname === `/guard/attendees/${attendeeId}` &&
  //     varify !== "false"
  //   ) {
  //     if (token) {
  //       handleMarkAttendeeCheckInOrOut();

  //       // searchParams.set("varify", "false");
  //       // navigate({ search: "?" + searchParams.toString() });
  //     } else {
  //       window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
  //     }
  //   }
  // }, [location.pathname]);

  // const handleMarkAttendeeCheckInOrOut = async () => {
  //   try {
  //     const res = await sendRequest(
  //       `${MarkAttendeeCheckInOrCheckOut}/${attendeeId}`,
  //       {
  //         method: "GET",
  //         guardToken: token,
  //       }
  //     );
  //     if (res.status === 1) {
  //       getDetails();
  //       setStatus(res.data);
  //       // alert("Attendee is not valid");
  //       navigate(`/guard/attendees/${attendeeId}?varify=false`, {
  //         replace: true,
  //       });
  //       // setDetails(res.data.attendee);
  //     }
  //   } catch (error) {
  //     console.log({ error });
  //   }
  // };

  return (
    <MainComponentWrapper
      Loading={isLoading || loading}
      errorInfo={isError || error}
    >
      <div className="event-attendee-detail-body">
        <AttendeeProfileCard details={details?.attendee} />
        <EventCard details={details?.event} />
      </div>
      {status && status !== null && details?.attendee?.status && !isLoading && (
        <ModalWrapper
          title={status === 'not-valid ? "Expired" : "Success"'}
          isShow={status !== null}
          clickHandler={() => setStatus(null)}
          CloseModalHandler={() => setStatus(null)}
          className={
            status === "not-valid" || status === "cancelled"
              ? "bg-danger"
              : "bg-success"
          }
        >
          {/* {status === "not-valid" ? (
            <p>Ticket is not valid</p>
          ) : details?.attendee?.status === "check-in" && (
            <p>Check-in Success</p>
          )  details?.attendee?.status === "check-out"  (
            <p>Check-out Success</p>
          )} */}

          {
            <>
              {status === "not-valid" ? (
                <p>Ticket is not valid</p>
              ) : status === "cancelled" ? (
                <p>Ticket has been Cancelled</p>
              ) : (
                <>
                  {details?.attendee?.status === "check-in" && (
                    <p>Check-in Success</p>
                  )}
                  {details?.attendee?.status === "check-out" && (
                    <p>Check-out Success</p>
                  )}
                </>
              )}
            </>
          }
        </ModalWrapper>
      )}
    </MainComponentWrapper>
  );
};

export default AttendeeDetials;
